import Vue from "vue";
import { Popup } from "mapbox-gl";
import RgPopup from "../components/RgPopup.vue";

export function usePopupManager({ map, pathManager }) {
  const popupInstances = new Map();
  let selectedObjectIds = new Set();

  const hasPopup = id => popupInstances.has(id);

  const appendPopup = (properties, points) => {
    const ComponentClass = Vue.extend(RgPopup);
    const instance = new ComponentClass({
      propsData: {
        objectId: properties.id,
        elId: `rg-popup-${properties.id}`,
        points: points,
      },
    });

    // --- イベント登録 ---
    instance.$on("onClickTrackBtn", coordinates => {
      map.flyTo({ center: coordinates, zoom: 13 });
    });

    instance.$on("onClickCloseBtn", objectId => {
      removePopup(objectId);
      pathManager.removeObjectFromSource(objectId);
    });

    instance.setData(properties);

    instance.$mount();

    const popup = new Popup({
      className: "rg-popup-wrapper",
      draggable: true,
      closeButton: false,
      closeOnClick: false,
    })
      .setLngLat([properties.log, properties.lat])
      .setDOMContent(instance.$el)
      .addTo(map);

    popupInstances.set(properties.id, instance);

    selectedObjectIds.add(properties.id);
  };

  const updatePopup = (properties, isDelete) => {
    if (popupInstances.has(properties.id)) {
      let instance = popupInstances.get(properties.id);
      if (!isDelete) {
        instance.setData(properties);
      } else {
        instance.setError("このオブジェクトは監視対象から外れました");
        instance.turnOffMonitoring();
      }
    }
  };

  const removePopup = popupId => {
    const instance = popupInstances.get(popupId);
    if (instance) {
      instance.$destroy();
      instance.$el.parentNode.removeChild(instance.$el);
      popupInstances.delete(popupId);
    }
    selectedObjectIds.delete(popupId);
  };

  const cleanupPopups = () => {
    popupInstances.forEach((_, id) => removePopup(id));
    selectedObjectIds.clear();
  };

  const getSelectedObjectIds = () => {
    return Array.from(selectedObjectIds);
  };

  const updateSelectedPopups = latestObjectsMap => {
    selectedObjectIds.forEach(objectId => {
      const latestObject = latestObjectsMap.find(obj => obj.id === objectId);
      if (latestObject && popupInstances.has(objectId)) {
        const instance = popupInstances.get(objectId);
        instance.setData(latestObject);
      }
    });
  };

  return {
    popupInstances,
    hasPopup,
    appendPopup,
    updatePopup,
    removePopup,
    cleanupPopups,
    getSelectedObjectIds,
    updateSelectedPopups,
  };
}
